<template>
  <div style="height: 100%;">
    <wx-kanban v-show="active===0" style="overflow-y: auto;" :style="MainHeihgt"></wx-kanban>
    <wx-work-list v-show="active===1"
                  style="overflow-y: auto; height: 100%; padding-bottom: 80px">
    </wx-work-list>
    <wx-my-info v-show="active===2"></wx-my-info>
    <van-tabbar v-model="active">
      <van-tabbar-item>
        概况
        <template #icon>
          <i class="el-icon-odometer"></i>
        </template>
      </van-tabbar-item>
      <van-tabbar-item>
        工单
        <template #icon>
          <i class="el-icon-files"></i>
        </template>
      </van-tabbar-item>
      <van-tabbar-item>
        我的
        <template #icon>
          <i class="el-icon-user"></i>
        </template>
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
  import { Button, Tabbar, TabbarItem } from 'vant'
  import WxKanban from '@/views/wx/WxKanban'
  import WxWorkList from '@/views/wx/WxWorkList'
  import WxMyInfo from '@/views/wx/WxMyInfo'
  import { myWorkScope, punchTimeList } from '@/utils/request'

  export default {
    provide () {
      return {
        reload: (active) => {
          this.active = active
        }
      }
    },
    name: 'WxMain',
    components: {
      WxMyInfo,
      WxWorkList,
      WxKanban,
      [Button.name]: Button,
      [Tabbar.name]: Tabbar,
      [TabbarItem.name]: TabbarItem
    },
    data () {
      return {
        active: 0,
        team: {},
        punchTimeList: []
      }
    },
    created () {
      if (this.$route.query.active) {
        this.active = parseInt(this.$route.query.active)
      }
      this.$store.dispatch('work/getKanbanWorks', 0)
      if (this.$isTechnician()) {
        myWorkScope().then(response => {
          this.$store.state.user.workScope = response.data
        })
      }
      punchTimeList().then(response => {
        this.$store.state.user.punchTimeList = response.data
      })

      if (this.$store.state.data.PAY_METHOD === undefined) {
        this.$store.dispatch('data/kvList', 'PAY_METHOD')
      }
      if (this.$store.state.data.INSURANCE_COMPANY === undefined) {
        this.$store.dispatch('data/kvList', 'INSURANCE_COMPANY')
      }
      if (this.$store.state.data.ConsultantsOfShop === undefined) {
        this.$store.dispatch('data/kvList', 'ConsultantsOfShop')
      }
      if (this.$store.state.data.OUTSIDE_REWORK_REASON === undefined) {
        this.$store.dispatch('data/kvList', 'OUTSIDE_REWORK_REASON')
      }
    },
    computed: {
        MainHeihgt () {
            return {
                height: (window.innerHeight - 50) + 'px'
            }
        }
    }
  }
</script>

<style scoped>

</style>
